// removed by extract-text-webpack-plugin
module.exports = {"MessageListWrapper":"_2rb2gTWN1TSRv28AhnodXN"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Conversation/MessagesList/index.css
// module id = 2004
// module chunks = 0